import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  chipLow: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
  },
  chipMedium: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.common.white,
  },
  chipHigh: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
  },
  chipActive: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
  },
  chipInactive: {
    backgroundColor: theme.palette.text.disabled,
    color: theme.palette.common.white,
  },
  iconCell: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  toolIcon: {
    width: 20,
    height: 20,
    objectFit: 'contain',
    flexShrink: 0,
  },
}))

export default useStyles
